import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

// Fresh, distinct color palette — no grey
const HIGH_COLOR  = '#0ea5e9'; // sky-500 – top performers
const MID_COLOR   = '#f59e0b'; // amber-500 – mid range
const LOW_COLOR   = '#f97316'; // orange-500 – lower

const BottleSizesHorizontalChart = ({ data }) => {
  const { t } = useLanguage();
  const filteredData = data.filter(item => item.qty > 0);

  if (filteredData.length === 0) {
    return (
      <div className="text-gray-400 text-center py-8 text-sm">
        {t('noOrdersFound')}
      </div>
    );
  }

  const total = filteredData.reduce((sum, item) => sum + item.qty, 0);
  const maxQty = filteredData[0]?.qty || 1;

  const getBarColor = (qty) => {
    if (qty >= total * 0.30) return HIGH_COLOR;
    if (qty >= total * 0.12) return MID_COLOR;
    return LOW_COLOR;
  };

  return (
    <div className="w-full py-2">
      {/* Legend */}
      <div className="flex items-center justify-center gap-4 mb-4 text-xs text-gray-500">
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: LOW_COLOR }} />
          <span>{t('lowSales')}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: MID_COLOR }} />
          <span>{t('averageSales')}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: HIGH_COLOR }} />
          <span>{t('highSales')}</span>
        </div>
      </div>

      {/* Bars */}
      <div className="space-y-3.5 px-2 pb-3">
        {filteredData.map((item, index) => {
          const widthPercent = Math.max((item.qty / maxQty) * 100, 5);
          const color = getBarColor(item.qty);

          return (
            <div key={index}>
              <div className="flex justify-between items-center mb-1">
                <span className="text-xs font-semibold text-gray-700 truncate max-w-[65%]">
                  {item.displayName}
                </span>
                <span className="text-xs font-bold text-gray-800 ml-2 flex-shrink-0">
                  {item.qty.toLocaleString()}
                </span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-4 overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${widthPercent}%`, backgroundColor: color }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BottleSizesHorizontalChart;
